var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"strategy-info-btn",on:{"click":function($event){return _vm.navigateSingleStrat(_vm.data)}}},[_vm._v(" More info ")])}
var staticRenderFns = []

export { render, staticRenderFns }